import {
  CART_ADD_ITEM,
  CART_DECREASE_ITEM,
  CART_REMOVE_ITEM,
  CART_RESET,
} from "../constants/cartConstants";

export const cartReducer = (state = { cartItems: [] }, action) => {
  switch (action.type) {
    case CART_ADD_ITEM:
      const item = action.payload;

      const existItem = state.cartItems.find((x) => x.product === item.product);
      if (existItem) {
        return {
          ...state,
          cartItems: state.cartItems.map((x) =>
            x.product === existItem.product ? { ...item } : x
          ),
        };
      } else {
        return {
          ...state,
          cartItems: [...state.cartItems, item],
        };
      }
    case CART_REMOVE_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter((x) => x.product !== action.payload),
      };
    case CART_DECREASE_ITEM:
      const newItem = action.payload;

      const existItem2 = state.cartItems.find(
        (x) => x.product === newItem.product
      );
      if (existItem2) {
        return {
          ...state,
          cartItems: state.cartItems.map((x) =>
            x.product === existItem2.product ? { ...newItem } : x
          ),
        };
      }

    case CART_RESET:
      return { ...state, cartItems: [] };
    default:
      return state;
  }
};
